"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CXTupleToDefaultPreferencesResult = void 0;
const data_type_1 = require("../../data/data-type");
const query_output_1 = require("./query-output");
/**
 * Data available as part of a CXTuple Defaults query result.
 */
class CXTupleToDefaultPreferencesResult extends query_output_1.QueryOutput {
}
exports.CXTupleToDefaultPreferencesResult = CXTupleToDefaultPreferencesResult;
/**
 * Default currency is stored in String format.
 */
CXTupleToDefaultPreferencesResult.DEFAULT_CURRENCY = new CXTupleToDefaultPreferencesResult('default_currency', data_type_1.DataType.STRING);
/**
 * Default language is stored in String format.
 */
CXTupleToDefaultPreferencesResult.DEFAULT_LANGUAGE = new CXTupleToDefaultPreferencesResult('default_language', data_type_1.DataType.STRING);
//# sourceMappingURL=cx-tuple-to-default-preferences-result.js.map